import * as React from "react";
const SvgFiRrHiking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hiking_svg__a)">
      <path
        fill="#062147"
        d="m9.665 19.15-.6 3.975a1 1 0 0 1-1.977-.3l.6-3.975a1 1 0 1 1 1.977.3M21.048 8v15a1 1 0 0 1-2 0V12h-3a1 1 0 0 1-.895-.553l-.637-1.275-.459 2.52a1 1 0 0 1-1.163.805 1 1 0 0 1-.8-1.164l.788-4.324c-.023 0-.044-.009-.066-.009h-1.93L9.9 13.36a1 1 0 0 0 .436 1.042l4.252 2.759a1 1 0 0 1 .455.839v5a1 1 0 0 1-2 0v-4.457l-3.8-2.463a3 3 0 0 1-.743-.694A3.3 3.3 0 0 1 6.537 16c-1.67 0-3.47-1.252-3.47-4 0-3.364 3.037-6 6.914-6h2.831A2.98 2.98 0 0 1 15.5 7.658L16.666 10h2.382V8a1 1 0 1 1 2 0m-13.07 4.793.85-4.676C6.832 8.508 5.068 9.9 5.068 12c0 1.9 1.224 2 1.47 2a1.49 1.49 0 0 0 1.44-1.207M13.047 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hiking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHiking;
